function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Story-editor-Writing-text-selected-color-preview",
  transform: "translate(-1621.000000, -233.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "delete-11-copy",
  transform: "translate(1614.000000, 228.000000)"
}, React.createElement("g", {
  id: "baseline-delete-24px",
  transform: "translate(7.200000, 5.400000)"
}, React.createElement("path", {
  d: "M1.54285716,24.0000003 C1.54285716,25.6500004 2.93142857,27.0000004 4.6285714,27.0000004 L16.9714284,27.0000004 C18.6685712,27.0000004 20.0571426,25.6500004 20.0571426,24.0000003 L20.0571426,5.99999986 L1.54285716,5.99999986 L1.54285716,24.0000003 Z M21.6,1.5 L16.2,1.5 L14.6571429,0 L6.94285714,0 L5.4,1.5 L0,1.5 L0,4.5 L21.6,4.5 L21.6,1.5 Z",
  id: "Shape"
})))));

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "22px",
    height: "28px",
    viewBox: "0 0 22 28",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.71b5d7c0.svg";
export { ForwardRef as ReactComponent };